import { TabDetailParameterName } from '@common-modules/dependencies/navigation/tab-detail-panel-parameters';
import { FilterAdapterEnum } from '@common-modules/dependencies/wlm-filters/filter-adapter.enum';
import { ArrayValuesFAdapter } from './array-values-f-adapter';

export class ElementTargetFAdapter extends ArrayValuesFAdapter {
  constructor(init: {
    dataBindingField: string;
    fieldName: string;
    tabParameter: TabDetailParameterName;
    multiple: boolean;
  }) {
    super(init);
    this.id = FilterAdapterEnum.ElementTarget;
  }
}
